module.exports = __webpack_public_path__ + "img/tcndxq_img4_gray-6.bc26f1cb.png";